import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Panel } from 'primereact/panel';
import { ProgressSpinner } from 'primereact/progressspinner';
import { InputComponent } from '../../../../components/InputComponent';
import { FileComponent } from '../../../../components/FileComponent';
import { VisorPdf } from '../../../../components/VisorPdf';
import { ProveedorService } from '../../../../service/ProveedorService';
import * as generic from '../../../../components/Generico';
import { InfoDeclaracion } from '../../../../models/ficha/InfoDeclaracion';
import { ReferenciaComercial } from '../../ReferenciaComercial';
import { BottomActionBar } from '../../../../components/ui/BottomActionBar';

export const Declaracion = ({ toast, id, permss, catalogos, estado, urls, setDialogAnexos, handlePrev, soloLectura }) => {
    const omodel = new InfoDeclaracion({ tipoFrmEmpresa: catalogos?.tipoFrmEmpresa });
    const defaultValues = generic.funDefault(omodel.model);
    const { control, formState: { errors }, handleSubmit, reset, setError } = useForm({ defaultValues, shouldTrim: true });
    const proveedorServicio = new ProveedorService();
    const { inArea, inDrop, downloadPdf } = InputComponent({ omodel, errors, control, permss, id, soloLectura });
    const { enviarFormulario } = FileComponent({ tipo: 'proveedor', toast, unuevo: 'ficha/proveedor/store', udelete: 'ficha/proveedor/eliminar-anexo', permss, id });
    // Estados Locales para Botones y PDF
    const [isSaving, setIsSaving] = useState(false); // Spinner de "Guardar"
    const [loadReport, setLoadReport] = useState(false); // Spinner de "Generar PDF"
    const [firmaActiva, setFirmaActiva] = useState(false);
    const [dialogVisor, setDialogVisor] = useState(false);
    const [pdfUrl, setPdfUrl] = useState({ url: null, name: '' });
    const [isLoading, setIsLoading] = useState(true);
    const [anexosRequisitos, setAnexosRequisitos] = useState([]);

    useEffect(() => {
        editFicha();
        // eslint-disable-next-line
    }, [id]);

    const editFicha = () => {
        setIsLoading(true);
        proveedorServicio.consultarProveedor(id, { seccion: 'seccion4' }).then(res => {
            if (res.data.firmaActiva !== undefined) {
                setFirmaActiva(res.data.firmaActiva);
            }

            const _prov = res.data.proveedor;
            if (!_prov) {
                reset(defaultValues);
                return;
            }
            if (res.data.anexos_requisitos !== undefined) {
                setAnexosRequisitos(res.data.anexos_requisitos);
            }
            reset(generic.renewValues(_prov, omodel.model));
        }).finally(() => {
            setIsLoading(false);
        });
    }

    const onSubmit = (data) => {
        data.id = id;
        data.seccion = 'seccion4'; // Identificador para el backend

        setIsSaving(true);
        proveedorServicio.editarProveedor(data).then(res => {
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcError(error, toast, setError);
        }).finally(() => {
            setIsSaving(false);
        });
    }

    // LÓGICA DE PDF Y ENVÍO
    const descargarDocumento = (firmar = false) => {
        setLoadReport(true);
        proveedorServicio.descargar(id, firmar, estado, { tipoFrmEmpresa: catalogos?.tipoFrmEmpresa }).then(res => {
            const blob = new Blob([res], { type: "application/pdf" });
            const fileURL = URL.createObjectURL(blob);
            const fileName = `${id}-Formulario-Informacion-Proveedor-Firmado.pdf`;
            setPdfUrl({ url: fileURL, name: fileName });
            setDialogVisor(true);
        }).catch(error => {
            generic.funcMessageBlobError('Complete la información antes de generar.', error, toast);
        }).finally(() => setLoadReport(false));
    };

    const generarReporte = (firmar = false) => {
        setLoadReport(true);

        const esEnviado = firmaActiva && estado === "ENVIADO";
        const firmarParam = esEnviado ? false : firmar;
        const nemonicoParam = esEnviado ? estado : undefined;

        proveedorServicio.descargar(id, firmarParam, nemonicoParam, { tipoFrmEmpresa: catalogos?.tipoFrmEmpresa }).then(res => {
            if (!firmaActiva) {
                downloadPdf(res, `${id}-Formulario-Informacion-Proveedor.pdf`);
                return;
            }

            const blob = new Blob([res], { type: "application/pdf" });
            const fileURL = URL.createObjectURL(blob);
            const fileName = esEnviado
                ? `${id}-Formulario-Informacion-Proveedor-Firmado.pdf`
                : `${id}-Formulario-Informacion-Proveedor.pdf`;
            setPdfUrl({ url: fileURL, name: fileName });
            setDialogVisor(true);
        }).catch(error => {
            generic.funcMessageBlobError('Complete la información antes de generar.', error, toast);
        }).finally(() => setLoadReport(false));
    }

    const subirReporte = () => {
        if (setDialogAnexos) setDialogAnexos(true);
    }

    const enviar = (tipoStr = null) => {
        enviarFormulario(id, `ficha/proveedor/enviar?tipoFrmEmpresa=${catalogos?.tipoFrmEmpresa ?? ''}`, 'proveedor');
    }

    const onError = () => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se detectaron errores en la validación.', life: 3000 });
    }

    if (isLoading) {
        return (
            <div className="flex flex-column align-items-center justify-content-center p-5">
                <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" animationDuration=".5s" />
                <span className="mt-3 text-color-secondary font-medium text-lg">Consultando información...</span>
            </div>
        );
    }

    return (
        <>
            {catalogos?.tipoFrmEmpresa === 'FRM_DIFARE' && (
                <Panel header={generic.renderPanelHeader('', 'REFERENCIAS', 'pi pi-shop')} className="panel-ficha shadow-1 mb-4">
                    <ReferenciaComercial tipo="proveedor" id={id} toast={toast} permss={permss} soloLectura={soloLectura} tipoFrmEmpresa={catalogos?.tipoFrmEmpresa} />
                </Panel>
            )}

            <form onSubmit={handleSubmit(onSubmit, onError)} className="p-fluid">

                <Panel header={generic.renderPanelHeader('', 'DECLARACIÓN', 'pi pi-file-edit')} className="panel-ficha shadow-1 mb-4">
                    <div className="field col-12 p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500 mb-0">
                        <div className="flex align-items-center gap-2 mb-3">
                            <i className="pi pi-info-circle text-blue-600 text-lg"></i>
                            <span className="font-bold text-blue-900">Términos de la Declaración</span>
                        </div>
                        {omodel.strDeclaracion}
                    </div>
                </Panel>

                <Panel header={generic.renderPanelHeader('', catalogos?.tipoFrmEmpresa === 'FRM_TOYOTA' ? 'Tratamiento de Datos Personales' : 'Autorización para Tratamiento de Datos', 'pi pi-lock')} className="panel-ficha shadow-1 mb-4">
                    <div className="field col-12 p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500 mb-0">
                        <div className="flex align-items-center gap-2 mb-3">
                            <i className="pi pi-shield text-blue-600 text-lg"></i>
                            <span className="font-bold text-blue-900">Tratamiento de Datos Personales</span>
                        </div>
                        {!['FRM_TOYOTA', 'FRM_DIFARE'].includes(catalogos?.tipoFrmEmpresa) && omodel.strAutorizacionTratamientoDatos}
                        {catalogos?.tipoFrmEmpresa === 'FRM_TOYOTA' && omodel.strToyota}
                        {catalogos?.tipoFrmEmpresa === 'FRM_DIFARE' && omodel.strDifare}
                    </div>
                </Panel>

                {catalogos?.tipoFrmEmpresa === 'FRM_TOYOTA' && (
                    <Panel header={generic.renderPanelHeader('', 'Consentimiento para el Uso de Datos Personales', 'pi pi-shield')} className="panel-ficha shadow-1 mb-4">
                        <div className="formgrid grid align-items-center">
                            <div className="field col-12 p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500 mb-4">
                                {omodel.strConceder}
                            </div>

                            {inDrop('uso_dato_personal', generic.estadosSiNo, { lab: 'nombre' }, 4)}

                            <div className="field col-8 p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500 mb-0">
                                {omodel.strActividad}
                            </div>
                        </div>
                    </Panel>
                )}

                {!['FRM_TOYOTA', 'FRM_DIFARE'].includes(catalogos?.tipoFrmEmpresa) && (
                    <Panel header={generic.renderPanelHeader('7', 'Observaciones', 'pi pi-comment')} className="panel-ficha shadow-1 mb-4">
                        <div className="formgrid grid">
                            {inArea('observacion', 5, 1000, 12)}
                        </div>
                    </Panel>
                )}

                <Panel header={generic.renderPanelHeader('8', 'Anexos', 'pi pi-paperclip')} className="panel-ficha shadow-1 mb-4">
                    <div className="formgrid grid">
                        <div className="field col-12 p-3 text-justify line-height-3 text-700 bg-yellow-50 border-round border-left-3 border-yellow-500 mb-0">
                            <div className="flex align-items-center gap-2 mb-3">
                                <i className="pi pi-file text-yellow-600 text-lg"></i>
                                <span className="font-bold text-yellow-900">Requisitos de Adjuntos</span>
                            </div>
                            <ul className="pl-4 m-0">
                                {anexosRequisitos?.map((req, index) => (
                                    <li key={index} className="mb-1">{req}</li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </Panel>

                <BottomActionBar
                    onPrev={handlePrev}
                    onSave={true}
                    onGenerate={generarReporte}
                    onSend={enviar}
                    onAttachments={subirReporte}
                    loading={isSaving || loadReport}
                    isReadOnly={soloLectura}
                    enableExtras={id != null}
                />
            </form>

            <VisorPdf visible={dialogVisor} onHide={() => setDialogVisor(false)} fileBlobUrl={pdfUrl.url} fileName={pdfUrl.name} firmar={() => descargarDocumento(true)} firmarEnviar={() => enviar('firmarEnviar')} id={id} tipo='proveedor' urls={urls} toast={toast} />
        </>
    );
}